import { useFetch } from '../../../hooks/useFetch';
import { Pageable, PageableResponseWrapper, PageQueryParams } from '../../../domain/response-wrapper';
import { Merchant } from '../../../domain/merchant';
import { usePagination } from '../../../hooks/usePagination';

interface AuditorMerchantQueryParams extends PageQueryParams {
}

const initialParams: AuditorMerchantQueryParams = {
  page: 0,
  size: 5,
};

export const useAuditorMerchantsData = () => {
  const { updateParams, nextPage, queryParams, prevPage, setParam } = usePagination<AuditorMerchantQueryParams>(initialParams);
  const { data, loading, error } = useFetch<PageableResponseWrapper<Merchant>>('/merchants-view/auditor', queryParams);

  return {
    data,
    loading,
    error,
    setParam,
    updateParams,
    nextPage,
    prevPage,
  };
};
